import * as React from "react";
import "./index.scss";
import {imageBaseUrl} from "config";

interface IProps {
    buttonText: string;
    iconUrl?: string;
    onClick: () => void;
    isDisabled?: boolean;
    bgColor?: string;
}

export const IconButton = (props: IProps) => {
    const buttonStyle = {
        display: "flex",
        justifyContent: "center",
        backgroundColor: !props.isDisabled ? props.bgColor ? props.bgColor : "#434175" : "#898989",
        borderRadius: 6,
        fontSize: 18,
        fontWeight: 700,
        color: "#FFFFFF",
        width: "100%",
        height: 47,
    };
    return (
        <div className={`icon-button ${props.isDisabled ? " disabled" : ""}`}
             style={buttonStyle}
             onClick={() => props.onClick()}>
            <div className="button-content">
                <div className="button-text">
                    {props.buttonText}
                </div>
                {props.iconUrl ?
                <div className="icon">
                    <img src={props.iconUrl} alt="icon"/>
                </div> : null}
            </div>
        </div>
    );
};

export default IconButton;
